document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('subToggle');
    const subBadges = document.querySelector('.subscription-badges');
    const oneTimeBadges = document.querySelector('.one-time-badges');

    function updateBadges(state) {
        if (!subBadges || !oneTimeBadges) return;
        if (state === 'subscribe') {
            subBadges.style.display = 'flex';
            oneTimeBadges.style.display = 'none';
        } else {
            subBadges.style.display = 'none';
            oneTimeBadges.style.display = 'flex';
        }
    }

    function applyRechargeClick(state) {
        const subLabel = document.querySelector('label[data-option-subsave]');
        const oneTimeLabel = document.querySelector('label[data-option-onetime]');
        const originalPrice = document.querySelector('.product-price .original-price');
        
        if (!subLabel || !oneTimeLabel) return;

        if (state === 'subscribe') {
            subLabel.click();
            if (originalPrice) {
                originalPrice.style.display = '';
            }
        } else {
            if (originalPrice) {
                originalPrice.style.display = 'none';
            }
            oneTimeLabel.click();
        }
    }

    // Function to extract numeric value from price text (handles different currency formats)
    function extractPriceValue(priceText) {
        if (!priceText) return 0;
        // Remove currency symbols, spaces, and extract numeric value
        const numericValue = priceText.replace(/[^\d.,]/g, '');
        // Handle comma as thousands separator vs decimal separator
        if (numericValue.includes(',') && numericValue.includes('.')) {
            // Format like 1,234.56 - comma is thousands separator
            return parseFloat(numericValue.replace(/,/g, ''));
        } else if (numericValue.includes(',') && numericValue.lastIndexOf(',') > numericValue.length - 4) {
            // Format like 1234,56 - comma is decimal separator
            return parseFloat(numericValue.replace(',', '.'));
        } else {
            // Standard format
            return parseFloat(numericValue.replace(/,/g, ''));
        }
    }

    // Function to get discount percentage from Recharge
    function getDiscountPercentage() {
        const subscriptionPriceEl = document.querySelector('.price.recharge-inner-most-price') ||
                                   document.querySelector('.rc_widget__price--subsave');
        const oneTimePriceEl = document.querySelector('.rc_widget__price--onetime');
        
        if (subscriptionPriceEl && oneTimePriceEl) {
            const subscriptionPrice = extractPriceValue(subscriptionPriceEl.textContent);
            const oneTimePrice = extractPriceValue(oneTimePriceEl.textContent);
            
            if (subscriptionPrice && oneTimePrice && oneTimePrice > subscriptionPrice) {
                const discountPercent = ((oneTimePrice - subscriptionPrice) / oneTimePrice) * 100;
                console.log('Calculated discount from Recharge:', discountPercent, '%');
                return discountPercent;
            }
        }
        
        // Fallback: try to get from data attribute or default
        const wrapperEl = document.querySelector('[data-subscription-discount]');
        if (wrapperEl) {
            const defaultDiscount = parseFloat(wrapperEl.dataset.subscriptionDiscount);
            console.log('Using default discount from data attribute:', defaultDiscount, '%');
            return defaultDiscount;
        }
        
        return 0;
    }

    // Function to calculate and update subscription prices based on converted original price
    function updateSubscriptionPrices() {
        console.log('=== UPDATING SUBSCRIPTION PRICES ===');
        
        const customPriceElements = document.querySelectorAll('[data-recharge-add-to-cart-price]');
        const customOriginalElements = document.querySelectorAll('[data-recharge-add-to-cart-original-price]');
        
        // Get the already-converted original price
        const originalPriceEl = customOriginalElements[0];
        if (!originalPriceEl || !originalPriceEl.textContent.trim()) {
            console.log('No original price found, skipping update');
            return;
        }
        
        const originalPriceValue = extractPriceValue(originalPriceEl.textContent);
        const discountPercent = getDiscountPercentage();
        
        console.log('Original price (converted):', originalPriceEl.textContent, 'Value:', originalPriceValue);
        console.log('Discount percentage:', discountPercent, '%');
        
        if (originalPriceValue && discountPercent) {
            // Calculate discounted price from the converted original price
            const discountedValue = originalPriceValue * (1 - discountPercent / 100);
            
            // Format the price to match the original price format
            const originalText = originalPriceEl.textContent;
            const formattedDiscountedPrice = formatPriceToMatch(discountedValue, originalText);
            
            console.log('Calculated discounted price:', formattedDiscountedPrice);
            
            // Update subscription price elements
            customPriceElements.forEach(element => {
                // Only update subscription elements (when toggle is checked)
                if (toggle && toggle.checked) {
                    element.textContent = formattedDiscountedPrice;
                } else {
                    // For one-time purchase, use original price
                    element.textContent = originalPriceEl.textContent;
                }
            });
            
            // Update title with discount percentage
            updateDiscountTitle(discountPercent);
        }
    }
    
    // Function to format price to match the original format
    function formatPriceToMatch(value, originalText) {
        // Extract currency symbol and positioning from original text
        const currencyMatch = originalText.match(/^([^\d.,]+)|([^\d.,]+)$/);
        const currencySymbol = currencyMatch ? (currencyMatch[1] || currencyMatch[2]) : '$';
        const isPrefixed = originalText.match(/^[^\d.,]+/);
        
        // Determine decimal places from original
        const decimalMatch = originalText.match(/\.(\d+)/);
        const decimalPlaces = decimalMatch ? decimalMatch[1].length : 2;
        
        // Format the number
        let formattedNumber = value.toFixed(decimalPlaces);
        
        // Add thousands separators if original has them
        if (originalText.includes(',') && originalText.match(/\d{1,3}(,\d{3})+/)) {
            const parts = formattedNumber.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            formattedNumber = parts.join('.');
        }
        
        // Add currency symbol in correct position
        return isPrefixed ? currencySymbol + formattedNumber : formattedNumber + currencySymbol;
    }
    
    // Function to update discount title
    function updateDiscountTitle(discountPercent) {
        const titleElement = document.querySelector('.subscription-state .title:not(.title--large)');
        if (titleElement) {
            titleElement.textContent = `Subscribe and Save ${Math.round(discountPercent)}%`;
        }
    }

    // Force subscribe option if toggle is checked
    function forceSubscribeIfToggleChecked() {
        if (toggle && toggle.checked) {
            const subLabel = document.querySelector('label[data-option-subsave]');
            if (subLabel && !subLabel.classList.contains('rc_widget__option--active')) {
                subLabel.click();
                updateBadges('subscribe');
                setTimeout(updateSubscriptionPrices, 300);
            }
        }
    }

    // Observe when Recharge mounts the radios
    function observeRechargeRadios() {
        const radiosContainer = document.querySelector('.rc-radio-group__options');
        if (!radiosContainer) {
            setTimeout(observeRechargeRadios, 150);
            return;
        }
        
        const radiosObserver = new MutationObserver(() => {
            forceSubscribeIfToggleChecked();
        });
        radiosObserver.observe(radiosContainer, { childList: true, subtree: true });
        forceSubscribeIfToggleChecked();
    }

    // Watch for changes in the original price (currency conversion)
    function observeOriginalPriceChanges() {
        const customOriginalElements = document.querySelectorAll('[data-recharge-add-to-cart-original-price]');
        
        customOriginalElements.forEach(element => {
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        console.log('Original price changed (currency conversion):', element.textContent);
                        // Update subscription prices when original price changes (currency conversion)
                        setTimeout(updateSubscriptionPrices, 100);
                    }
                });
            });
            
            observer.observe(element, { 
                childList: true, 
                subtree: true, 
                characterData: true 
            });
        });
    }

    // Watch for changes in Recharge discount elements to recalculate percentage
    function observeRechargeDiscountChanges() {
        const rechargeSelectors = [
            '.price.recharge-inner-most-price',
            '.rc_widget__price--subsave',
            '.rc_widget__price--onetime'
        ];
        
        rechargeSelectors.forEach(selector => {
            const observer = new MutationObserver(function(mutations) {
                console.log('Recharge discount element changed:', selector);
                setTimeout(updateSubscriptionPrices, 100);
            });
            
            // Observe existing elements
            document.querySelectorAll(selector).forEach(element => {
                observer.observe(element, { 
                    childList: true, 
                    subtree: true, 
                    characterData: true 
                });
            });
            
            // Watch for new elements
            const bodyObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) {
                            const elements = node.matches(selector) ? [node] : node.querySelectorAll(selector);
                            elements.forEach(element => {
                                observer.observe(element, { 
                                    childList: true, 
                                    subtree: true, 
                                    characterData: true 
                                });
                            });
                            setTimeout(updateSubscriptionPrices, 200);
                        }
                    });
                });
            });
            
            bodyObserver.observe(document.body, { childList: true, subtree: true });
        });
    }

    if (toggle) {
        // When user manually changes the toggle
        toggle.addEventListener('change', function () {
            const state = this.checked ? 'subscribe' : 'onetime';
            console.log('Toggle changed to:', state);
            applyRechargeClick(state);
            updateBadges(state);
            setTimeout(updateSubscriptionPrices, 300);
        });

        observeRechargeRadios();
    }

    // Sync custom dropdown with Recharge dropdown
    const customDropdown = document.querySelector('.subscription-dropdown');
    if (customDropdown) {
        const observer = new MutationObserver(() => {
            const rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
            if (rechargeDropdown) {
                customDropdown.addEventListener('change', function () {
                    const selectedValue = this.value;
                    const matchingOption = Array.from(rechargeDropdown.options).find((opt) => opt.value === selectedValue);
                    if (matchingOption) {
                        rechargeDropdown.value = selectedValue;
                        rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                        setTimeout(updateSubscriptionPrices, 300);
                    }
                });
                
                const initialSelected = customDropdown.value;
                rechargeDropdown.value = initialSelected;
                rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(updateSubscriptionPrices, 300);
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Choices.js for visual dropdown
    const dropdownEl = document.getElementById('custom-subscription-dropdown');
    if (dropdownEl) {
        const choices = new Choices(dropdownEl, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
        });

        const observer = new MutationObserver(() => {
            const rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
            if (rechargeDropdown) {
                dropdownEl.addEventListener('change', function () {
                    const selectedValue = this.value;
                    const option = Array.from(rechargeDropdown.options).find((opt) => opt.value === selectedValue);
                    if (option) {
                        rechargeDropdown.value = selectedValue;
                        rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                        setTimeout(updateSubscriptionPrices, 300);
                    }
                });
                
                rechargeDropdown.value = dropdownEl.value;
                rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(updateSubscriptionPrices, 300);
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Start all observers
    observeOriginalPriceChanges();
    observeRechargeDiscountChanges();

    // Listen for Recharge-specific events
    document.addEventListener('recharge:plan-changed', updateSubscriptionPrices);
    document.addEventListener('recharge:frequency-changed', updateSubscriptionPrices);

    // Listen for any selling plan changes in the form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
        productForm.addEventListener('change', function(e) {
            if (e.target.name && e.target.name.includes('selling_plan')) {
                setTimeout(updateSubscriptionPrices, 300);
            }
        });
    }

    // Initial price calculation with delays
    setTimeout(updateSubscriptionPrices, 500);
    setTimeout(updateSubscriptionPrices, 1500);
    setTimeout(updateSubscriptionPrices, 3000);
});